import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import EmailsPage from "@/pages/EmailsPage";
import DashboardPage from "@/pages/DashboardPage";
import ResourcePage from "@/pages/ResourcePage";
import OperationsPage from "@/pages/OperationsPage";
import TpePage from "@/pages/TpePage";
import RevendeursPage from "@/pages/RevendeursPage";
import SuperviseursPage from "@/pages/SuperviseursPage";
import TfjPage from "@/pages/TfjPage";
import JourneePage from "@/pages/JourneePage";
import GainsPage from "@/pages/GainsPage";
import CommissionsPage from "@/pages/CommissionsPage";
import TabsPage from "@/pages/TabsPage";
import DettesPage from "@/pages/DettesPage";
import RapportsPage from "@/pages/RapportsPage";
import UsersPage from "@/pages/UsersPage";
import ParametresPage from "@/pages/ParametresPage";
import AuditPage from "@/pages/AuditPage";
import TresoreriePage from "@/pages/TresoreriePage";
import ChargesPage from "@/pages/ChargesPage";
import StocksPage from "@/pages/StocksPage";

function Guard({ module, children }) {
  const { can } = useAuth();
  if (!can(module)) {
    return <div className="p-10 text-center text-muted-foreground" data-testid="access-denied">Accès refusé : vous n'avez pas la permission de consulter ce module.</div>;
  }
  return children;
}

function Protected() {
  const { user, meta } = useAuth();
  if (user === null || (user && !meta)) {
    return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">Chargement…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppLayout />;
}

const ROUTES = [
  ["/", "dashboard", <DashboardPage />],
  ["/tpe", "tpes", <TpePage />],
  ["/revendeurs", "revendeurs", <RevendeursPage />],
  ["/superviseurs", "superviseurs", <SuperviseursPage />],
  ["/tfj", "tfj", <TfjPage />],
  ["/tfj/journees/:id", "tfj", <JourneePage />],
  ["/tresorerie", "tresorerie", <TresoreriePage />],
  ["/operations", "operations", <OperationsPage />],
  ["/emails", "emails", <EmailsPage />],
  ["/gains", "gains", <GainsPage />],
  ["/commissions", "commissions", <CommissionsPage />],
  ["/charges", "charges", <ChargesPage />],
  ["/dettes", "dettes", <DettesPage />],
  ["/stocks", "stocks", <StocksPage />],
  ["/rapports", "rapports", <RapportsPage />],
  ["/utilisateurs", "utilisateurs", <UsersPage />],
  ["/audit", "audit", <AuditPage />],
  ["/parametres", "parametres", <ParametresPage />],
];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
            <Route path="/reinitialiser" element={<ResetPasswordPage />} />
            <Route element={<Protected />}>
              {ROUTES.map(([path, mod, el]) => (
                <Route key={path} path={path} element={<Guard module={mod}>{el}</Guard>} />
              ))}
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
